module.exports = __webpack_public_path__ + "img/image21.37e1646b.png";